import { useEffect, useState } from "react";
import { toast } from "sonner";
import { ArrowRight, History, Loader2, Mail, X } from "lucide-react";
import { fetchMoves, sendVisitsReport, sendWeeklyReport } from "@/lib/bf";

const when = (iso) => new Date(iso).toLocaleString("ro-RO", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });

export default function BFMoves() {
  const [rows, setRows] = useState(null);
  const [busy, setBusy] = useState("");
  const open = () => { setBusy("moves"); fetchMoves().then(setRows).catch(() => toast.error("Nu am putut încărca istoricul")).finally(() => setBusy("")); };
  useEffect(() => {
    const re = () => setRows((r) => { if (r) fetchMoves().then(setRows).catch(() => {}); return r; });
    window.addEventListener("bf-moves-refresh", re);
    return () => window.removeEventListener("bf-moves-refresh", re);
  }, []);
  const weekly = () => {
    setBusy("weekly");
    sendWeeklyReport().then((d) => toast.success(`Raport trimis adminilor: ${d.new} saloane noi în ultimele 7 zile`))
      .catch(() => toast.error("Nu am putut trimite raportul")).finally(() => setBusy(""));
  };
  const visits = () => {
    setBusy("visits");
    sendVisitsReport().then((d) => toast.success(`Raport de vizite trimis adminilor: ${d.visits} vizite, ${d.orders} comenzi`))
      .catch(() => toast.error("Nu am putut trimite raportul")).finally(() => setBusy(""));
  };
  return (
    <section className="invite-box" data-testid="bfa-moves">
      <h3>Istoric mutări saloane</h3>
      <p className="st-hint">Cine a mutat fiecare salon, când și de la ce agent la ce agent. Raportul săptămânal pleacă automat luni la 09:00, iar raportul de vizite vineri la 18:00, către toți adminii.</p>
      <div className="share-actions">
        {!rows && <button type="button" className="st-btn st-btn--light" onClick={open} disabled={!!busy} data-testid="bf-moves-open">{busy === "moves" ? <Loader2 size={14} className="animate-spin" /> : <History size={14} />} Vezi istoricul</button>}
        {rows && <button type="button" className="st-btn st-btn--ghost" onClick={() => setRows(null)} data-testid="bf-moves-close"><X size={14} /> Ascunde</button>}
        <button type="button" className="st-btn st-btn--ghost" onClick={weekly} disabled={!!busy} data-testid="bf-weekly-send">{busy === "weekly" ? <Loader2 size={14} className="animate-spin" /> : <Mail size={14} />} Trimite raportul săptămânal acum</button>
        <button type="button" className="st-btn st-btn--ghost" onClick={visits} disabled={!!busy} data-testid="bf-visits-send">{busy === "visits" ? <Loader2 size={14} className="animate-spin" /> : <Mail size={14} />} Trimite raportul de vizite acum</button>
      </div>
      {rows && !rows.length && <p className="st-hint" data-testid="bf-moves-empty">Nu a fost mutat încă niciun salon.</p>}
      {rows && rows.length > 0 && (
        <ul className="bf-moves" data-testid="bf-moves-list">
          {rows.map((m, i) => (
            <li key={`${m.lead}-${m.at}`} data-testid={`bf-move-${i}`}>
              <b>{m.salon || "Salon"}</b>
              <span className="bf-moves-path"><em>{m.from || "fără agent"}</em><ArrowRight size={13} /><em className="is-to">{m.to || "fără agent"}</em></span>
              <small>{when(m.at)} · {m.by || "-"}</small>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
